export default "__VITE_ASSET__BTNv15B6__"